module.exports = __webpack_public_path__ + "static/media/спа_мини.d9b39139.jpg";